// extracted by mini-css-extract-plugin
export default {"container":"CreateIssueForm_container__fWDoM","group":"CreateIssueForm_group__clHUm"};